module.exports = __webpack_public_path__ + "static/media/nature3.feada78c.jpeg";